import * as _ from 'lodash'
import React from 'react';
import jobCostNoteFactory from '../models/jobCostNoteModel';
import componentServices from '../componentServices';
import util from '../util';
import globalRelay from '../globalRelay';
import valueFilters from '../valueFilters';
import jobFactory from '../models/jobModel';
import { AsyncButton, Radio } from './sharedComponents';
import { getModel, ModelCollection } from '../store';

export default class JobCostEditSubmitBillingAdjustment extends React.Component<any, any> {
	private _afterNoteSaved;

	constructor(props) {
		super(props);

		this.state = this.getStateFromProps(props);
		this._afterNoteSaved = null;

		this.handleButtonClick = this.handleButtonClick.bind(this);
		this.handleNoteChange = this.handleNoteChange.bind(this);
		this.handleTransactionMethodChange = this.handleTransactionMethodChange.bind(this);
		this.handleTransactionReferenceChange = this.handleTransactionReferenceChange.bind(this);
		this.onInfoCorrectChange = this.onInfoCorrectChange.bind(this);
		this.printReport = this.printReport.bind(this);
	}

	UNSAFE_componentWillReceiveProps(newProps) {
		this.setState(this.getStateFromProps(newProps));
	}

	getStateFromProps(props) {
		const { store } = componentServices;
		const { jobCost } = props;
		const state = _.assign({ transactionMethod: '', transactionReference: '' }, this.state);
		const job = getModel({ store, collection: ModelCollection.jobs, key: jobCost.jobKey });

		if (state.jobCostKey !== jobCost.key || state.jobCostItemVersion !== jobCost.itemVersion) {
			if (state.jobCostKey !== jobCost.key) {
				state.infoCorrect = (['unlocked', 'rejected'].indexOf(jobCost.currentChangeOrder.currentStatus) !== -1) ? undefined : '1';

				const appliedPayments = job.getAppliedPayments(jobCost.currentChangeOrder.key);
				if (appliedPayments.length) {
					state.transactionMethod = appliedPayments[0].transactionMethod;
					state.transactionReference = appliedPayments[0].transactionReference;
				}
			}

			state.changeOrder = jobCost.currentChangeOrder;
			state.job = job;
			state.jobCostKey = jobCost.key;
			state.jobCostItemVersion = jobCost.itemVersion;
		}

		return state;
	}

	handleNoteChange(e) {
		const options = e.type === 'blur' ? { autoSave: true } : { autoSave: false };
		const newVal = e.type === 'blur' ? valueFilters.clean(e.target.value) : e.target.value;

		(options as any).callback = (err) => {
			if (!err && this._afterNoteSaved) {
				this._afterNoteSaved();
				this._afterNoteSaved = null;
			}
		};

		this.props.updateModel(jobCost => {
			const note = _.find(jobCost.notes, { type: jobCostNoteFactory.NOTE_TYPES.CONTRACT_FOR_OPERATIONS }) || jobCostNoteFactory({ type: jobCostNoteFactory.NOTE_TYPES.CONTRACT_FOR_OPERATIONS });

			note.content = newVal;
			jobCost.notes.set(note.key, note);
		}, options);
	}

	handleTransactionMethodChange(e) {
		const newVal = e.target.value;

		this.setState(previousState => {
			const newState = _.assign({}, previousState);

			newState.transactionMethod = newVal;

			return newState;
		});
	}

	handleTransactionReferenceChange(e) {
		const newVal = e.type === 'blur' ? valueFilters.clean(e.target.value) : e.target.value;

		this.setState(previousState => {
			const newState = _.assign({}, previousState);

			newState.transactionReference = newVal;

			return newState;
		});
	}

	hasOperationsNote() {
		const { jobCost } = this.props;

		return !!jobCost.getNoteContent(jobCostNoteFactory.NOTE_TYPES.CONTRACT_FOR_OPERATIONS);
	}

	canEnterNotes() {
		const { infoCorrect, transactionMethod, transactionReference } = this.state;

		return infoCorrect === '1' && transactionMethod && (['account', 'cash'].indexOf(transactionMethod) !== -1 || transactionReference);
	}

	canSubmit() {
		const { infoCorrect, transactionMethod, transactionReference } = this.state;

		return infoCorrect === '1' && transactionMethod && this.hasOperationsNote() && (['account', 'cash'].indexOf(transactionMethod) !== -1 || transactionReference);
	}

	onInfoCorrectChange(newButton) {
		if (['unlocked', 'rejected'].indexOf(this.state.changeOrder.currentStatus) === -1) {
			return;
		}

		// set state to force a re-render
		this.setState(previousState => {
			const newState = _.assign({}, previousState);

			newState.infoCorrect = newButton.value;

			return newState;
		});
	}

	handleButtonClick() {
		const saveState = componentServices.store.getIn(['viewState', 'globalSave', 'state']);
		const { summary } = this.props;
		const { job, transactionMethod, transactionReference } = this.state;
		const options = { autoSave: true };

		if (!this.canSubmit()) { return; }

		if (saveState !== 0) {
			this._afterNoteSaved = () => {
				this.handleButtonClick();
			};
			return;
		}

		this.props.updateModel(jobCost => {
			const changeOrder = jobCost.currentChangeOrder;

			changeOrder.statusLog.add({ status: 'pending-approval' });
			// lock in tax and warranty costs
			summary.writeCalculatedItems(jobCost.proxiedContract, changeOrder.key);
			summary.writeStats(jobCost.proxiedContract, changeOrder.key);

			const jobUpdate = jobFactory(job.toDocument());
			jobUpdate.payments.add({ changeOrderKey: changeOrder.key, type: 'other', appliedToContract: true, transactionMethod: transactionMethod, transactionReference: transactionReference, amount: changeOrder.adjustedSellPrice });

			const jobPatch = jobUpdate.getPatch(job);

			if (jobPatch.length) {
				(options as any).extraneousPatch = [{
					op: 'replace',
					path: '../job',
					value: jobPatch
				}];
			}
		}, options);
	}

	printReport() {
		const { fetchReport } = this.props;

		return fetchReport('contract/customer');
	}

	render() {
		const { jobCost, summary } = this.props;
		const { changeOrder, infoCorrect, job, transactionMethod, transactionReference } = this.state;
		const operationsNote = jobCost.getNoteContent(jobCostNoteFactory.NOTE_TYPES.CONTRACT_FOR_OPERATIONS);
		const infoCorrectButtons = [
			{ classNames: ['icon yes'], isSelected: (infoCorrect === '1'), value: '1' },
			{ classNames: ['icon no'], isSelected: (infoCorrect === '0'), value: '0' }
		];

		const infoCorrectRadio = (<Radio buttons={infoCorrectButtons} onChange={this.onInfoCorrectChange} />);

		const submitButtonClasses = ['action', 'iconLabel', 'submitToOrderDesk'];

		if (changeOrder.currentStatus !== 'locked') {
			submitButtonClasses.push('locked');
		}
		if (!this.canSubmit()) {
			submitButtonClasses.push('disabled');
		}

		const submitted = ['unlocked', 'rejected'].indexOf(changeOrder.currentStatus) === -1;
		const submitButtonText = submitted ? 'IN REVIEW BY ORDER DESK' : 'SUBMIT TO ORDER DESK';
		const submitButton = ['unlocked', 'rejected', 'pending-approval'].indexOf(changeOrder.currentStatus) !== -1 ? (<button className={submitButtonClasses.join(' ')} onClick={this.handleButtonClick}><span> {submitButtonText}</span></button>) : null;

		return (
			<section className="jobCostFinalize">
				<header>
					<span>REVIEW BILLING ADJUSTMENT INFORMATION</span>
					<div className="actions">
						<AsyncButton className="pdf" asyncAction={this.printReport} label="Print" />
					</div>
				</header>
				<div className="inner compact">

					<table className="" cellPadding="0" cellSpacing="0">
						<tbody>
							<tr>
								<td />
								<td><strong>Change Name</strong></td>
								<td>{changeOrder.name}</td>
								<td />
							</tr>
							<tr>
								<td />
								<td><strong>Reason</strong></td>
								<td>{changeOrder.description}</td>
								<td />
							</tr>
							<tr>
								<td />
								<td><strong>Who is Paying?</strong></td>
								<td>{changeOrder.transactionAccount}</td>
								<td />
							</tr>
							<tr>
								<td />
								<td><strong>Amount</strong></td>
								<td>{util.formatAsCurrency(summary.orderTotalPrice)}</td>
								<td />
							</tr>
							<tr className={infoCorrect === '1' ? 'yes' : infoCorrect === '0' ? 'no' : ''}>
								<td />
								<td><strong>Is this information correct?</strong></td>
								<td>
									{infoCorrectRadio}
								</td>
								<td />
							</tr>
						</tbody>
					</table>
				</div>

				<section className={infoCorrect !== '1' ? 'disabled' : ''}>
					<header>
						<span>PAYMENT INFORMATION</span>
					</header>
					<div className='inner compact'>
						<table cellPadding="0" cellSpacing="0">
							<tbody>
								<tr className={(submitted ? 'disabled' : '')}>
									<td />
									<td><strong>Payment Method</strong></td>
									<td>
										<select value={util.reactVal(transactionMethod)} onChange={this.handleTransactionMethodChange}>
											<option value="">Select</option>
											<option value="cheque">{globalRelay.config!.getString('Cheque')}</option>
											<option value="credit-card">Credit Card</option>
											{job.builderKey ? <option value="purchase-order">Purchase Order</option> : null}
											<option value="cash">Cash</option>
											{job.builderKey ? <option value="account">Account</option> : null}
										</select>
									</td>
									<td />
								</tr>
								<tr className={(submitted ? 'disabled' : '')}>
									<td />
									<td><strong>Transaction Reference</strong></td>
									<td><input type="text" autoCapitalize="" autoCorrect="off" placeholder="" value={transactionReference} onChange={this.handleTransactionReferenceChange} onBlur={this.handleTransactionReferenceChange} /></td>
									<td />
								</tr>
							</tbody>
						</table>

					</div>
				</section>

				<section className={!this.canEnterNotes() ? 'disabled' : ''}>
					<header>
						<span>FINAL DETAILS</span>
					</header>
					<div className="inner compact">
						<table cellPadding="0" cellSpacing="0">
							<tbody>
								<tr className={(submitted ? 'disabled' : this.hasOperationsNote() ? '' : 'required')}>
									<td />
									<td><strong>Notes for Operations</strong></td>
									<td><textarea value={operationsNote} onChange={this.handleNoteChange} onBlur={this.handleNoteChange} /></td>
									<td />
								</tr>
								<tr className={(submitted || !this.canSubmit() ? 'disabled' : '')}>
									<td />
									<td />
									<td> {submitButton}</td>
									<td />
								</tr>
							</tbody>
						</table>

					</div>
				</section>

			</section>
		);
	}
}
